import { Plus } from 'lucide-react';
import BaseButton from '../base-button';

type Props = {
  size?: number;
  iconSize?: number;
  className?: string;
  onClick?: () => void;
};

const AddButton = ({ onClick, className, size = 32, iconSize = 16 }: Props) => {
  return (
    <BaseButton onClick={onClick} className="bg-blue-600 border-none" size={size}>
      <Plus size={iconSize} className="text-white" />
    </BaseButton>
  );
};

export default AddButton;
